// extracted by mini-css-extract-plugin
export default {"container":"ProjectPage_container__deIgR","content":"ProjectPage_content__CdgtY","header":"ProjectPage_header__A+VOC"};